import LayoutSettings from '@/components/LayoutSetting/LayoutSettings'
import { isEmpty } from '@/helpers'
import { deliverySettingSelector, handleSaveDeliverySettings } from '@/redux/slice/delivery.slice'
import { BlockStack, Button, InlineStack, Tag, TextField } from '@shopify/polaris'
import { PlusIcon } from '@shopify/polaris-icons'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

const DeliveryTags = () => {
  const { t } = useTranslation('deliverySettings')
  const deliverySettings = useSelector(deliverySettingSelector)
  const dispatch = useDispatch()
  const [valueTags, setValueTags] = useState<string>('')

  const handleAddTags = () => {
    if (!isEmpty(valueTags.trim())) {
      if (deliverySettings.additionalTags) {
        dispatch(handleSaveDeliverySettings({ additionalTags: [...deliverySettings.additionalTags, valueTags] }))
      } else {
        dispatch(handleSaveDeliverySettings({ additionalTags: [valueTags] }))
      }
      setValueTags('')
    }
  }

  const handleRemoveTag = (index: number) => {
    const listTags = deliverySettings.additionalTags
    const newListTags = listTags?.filter((_, idx) => idx !== index)
    dispatch(handleSaveDeliverySettings({ additionalTags: [...newListTags] }))
  }

  return (
    <LayoutSettings title={t('sections.deliveryTags.title')} helpText={t('sections.deliveryTags.helpText')}>
      <BlockStack gap={'100'}>
        <TextField
          label={t('sections.deliveryTags.label')}
          placeholder="Delivery"
          value={valueTags}
          onChange={(value: string) => setValueTags(value)}
          autoComplete="off"
          connectedRight={
            <Button onClick={handleAddTags} icon={PlusIcon} disabled={isEmpty(valueTags.trim())}>
              {t('sections.deliveryTags.addTags')}
            </Button>
          }
        />
        {deliverySettings.additionalTags.length > 0 && (
          <InlineStack gap={'100'}>
            {deliverySettings.additionalTags.map((item, index) => (
              <Tag key={`tag--${index}`} onRemove={() => handleRemoveTag(index)}>
                {item}
              </Tag>
            ))}
          </InlineStack>
        )}
      </BlockStack>
    </LayoutSettings>
  )
}

export default DeliveryTags
